module.exports = __webpack_public_path__ + "static/media/6.d630e009.png";